import React from 'react';
import PropTypes from 'prop-types';
import {
  Components, Theme, Utils, translate,
} from 'versafleet-core';
import MeasurementModule from 'modules/measurement';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import addOnsSettings from 'modules/addOns/addOnsConstants';
import moment from 'moment';
import CustomInfoView from './customInfoView';

function transitionToJobDetail(data) {
  // Copy path per layer until it hits either tasks or jobs
  let path = '';
  const currentPaths = Utils.Router.getPath().split('/').filter(v => v !== '');
  for (let i = 0; i < currentPaths.length; i += 1) {
    if (currentPaths[i] === 'tasks' || currentPaths[i] === 'jobs') {
      break;
    }
    path += `/${currentPaths[i]}`;
  }

  path += `/jobs/${data.job.id}`;
  Utils.Router.transitionTo(path);
}

class TaskDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAttachmentInput: false,
      openEpodAttachmentInput: false,
    };
  }

  componentDidMount() {
    this.props.dispatch(ReduxActions.account.fetchTrackingSetting());
  }

  _openTrackingSiteInNewTab() {
    const { data, trackingSetting } = this.props;
    const link = `${trackingSetting.tracking_url}/${data.tracking_id || data.guid}`;
    window.open(link, '_blank');
  }

  _getEtaComponent() {
    const { data, strings, trackingSetting } = this.props;

    const isTrackingEnabled = Utils.Helper.isNullOrUndefined(trackingSetting)
      ? false : trackingSetting.is_enabled && (!Utils.Helper.isNullOrUndefined(data.guid)
      || !Utils.Helper.isNullOrUndefined(data.tracking_id));
    const eta = Utils.Helper.isNullOrUndefined(data.task_assignment)
      || Utils.Helper.isNullOrUndefined(data.task_assignment.estimated_start_time) ? null
      : `${strings.Task.form.constants.eta}: ${moment(data.task_assignment.estimated_start_time).format('h:mm A')}`;

    return (
      <div>
        {isTrackingEnabled ? (
          <Components.Link onClick={() => this._openTrackingSiteInNewTab()}>
            {eta || strings.Task.form.constants.trackTask}
          </Components.Link>
        ) : eta}
      </div>
    );
  }

  _renderAdditionalInfo() {
    const { data, strings, myjobsSetting } = this.props;
    const codInputTemplate = (
      <div>
        <Components.Form.Block fontColor="GREY" level={1}>
          {strings.Task.form.additionalInfo.cod.title}
        </Components.Form.Block>
        <Components.Form.Block fontColor="TEXT" level={2}>
          {`${strings.Task.form.additionalInfo.cod.expected}: `}
          {data.expected_cod ? `$${data.expected_cod}` : strings.Task.form.additionalInfo.cod.notCollected}
        </Components.Form.Block>
        <Components.Form.Block fontColor="TEXT" level={2}>
          {`${strings.Task.form.additionalInfo.cod.actual}: `}
          {data.actual_cod ? `$${data.actual_cod}` : strings.Task.form.additionalInfo.cod.notCollected}
        </Components.Form.Block>
        <Components.Form.Divider />
      </div>
    );

    if (!myjobsSetting.show_additional_info) {
      return (
        <Components.Form.ExpandableContainer
          parent={(
            <Components.Form.Block fontWeight="BOLD" iconClassName="versa-subject" iconText="" level={0}>
              {strings.Task.form.additionalInfo.title}
            </Components.Form.Block>
          )}
        >
          <Components.Form.Divider />
          {codInputTemplate}
        </Components.Form.ExpandableContainer>
      );
    }

    return (
      <Components.Form.ExpandableContainer
        parent={(
          <Components.Form.Block fontWeight="BOLD" iconClassName="versa-subject" iconText="" level={0}>
            {strings.Task.form.additionalInfo.title}
          </Components.Form.Block>
        )}
      >
        <Components.Form.Divider size="MEDIUM" />

        {
          data.job.myjobs_rejection_notes[0] ? [
            (
              <Components.Form.Block fontWeight="BOLD" level={1}>
                {strings.Task.form.additionalInfo.jobRejected}
              </Components.Form.Block>
            ), (
              <Components.Form.Block level={1}>
                {data.job.myjobs_rejection_notes[0].content}
              </Components.Form.Block>
            ), (
              <Components.Form.Divider />
            ),
          ] : false
        }

        {myjobsSetting.show_note ? [(
          <Components.Form.Block
            className="vf-task__view-form__additional-info__remarks"
            iconClassName="versa-note"
            iconText=""
            level={1}
          >
            {data.remarks || strings.Job.form.additionalInfo.noRemarks}
          </Components.Form.Block>
        ), (
          <Components.Form.Divider />
        )] : false}

        {myjobsSetting.show_tags ? [(
          <Components.Form.Block iconClassName="versa-tags" iconText="" level={1}>
            <Components.Tags tags={(data.tags || []).map(tag => tag.name)} />
          </Components.Form.Block>
        ), (
          <Components.Form.Divider />
        )] : false}

        <Components.Form.Block iconClassName="versa-attachment" iconText="" level={1}>
          {Utils.UserAgentDetector.isMobileOrTablet() ? (
            <Components.Form.MobileAttachmentInput
              apiUrl={process.env.apiUrl}
              editable={false}
              id={`${this.props.id}__mobile-attachment-input`}
              onButtonClick={() => this.setState({ openAttachmentInput: true })}
              onClose={() => this.setState({ openAttachmentInput: false })}
              open={this.state.openAttachmentInput}
              value={data.photos}
            />
          ) : (
            <Components.Form.AttachmentInput
              apiUrl={process.env.apiUrl}
              editable={false}
              id={`${this.props.id}__attachment-input`}
              onButtonClick={() => this.setState({ openAttachmentInput: true })}
              onClose={() => this.setState({ openAttachmentInput: false })}
              open={this.state.openAttachmentInput}
              value={data.photos}
            />
          )}
        </Components.Form.Block>

        {this.props.account.addons_setting.use_own_epod === addOnsSettings.subscribed && (
          <React.Fragment>
            <Components.Form.Divider />
            <Components.Form.Block iconClassName="versa-attachment" iconText="" level={1}>
              {Utils.UserAgentDetector.isMobileOrTablet() ? (
                <Components.Form.MobileAttachmentInput
                  apiUrl={process.env.apiUrl}
                  buttonLabel={strings.Task.form.additionalInfo.epodAttachment.button}
                  editable={false}
                  emptyLabel={strings.Task.form.additionalInfo.epodAttachment.noAttachments}
                  id={`${this.props.id}__mobile-epod-attachment-input`}
                  onButtonClick={() => this.setState({ openEpodAttachmentInput: true })}
                  onClose={() => this.setState({ openEpodAttachmentInput: false })}
                  open={this.state.openEpodAttachmentInput}
                  title={strings.Task.form.additionalInfo.epodAttachment.title}
                  value={data.epod_attachments || []}
                />
              ) : (
                <Components.Form.AttachmentInput
                  apiUrl={process.env.apiUrl}
                  buttonLabel={strings.Task.form.additionalInfo.epodAttachment.button}
                  editable={false}
                  emptyLabel={strings.Task.form.additionalInfo.epodAttachment.noAttachments}
                  id={`${this.props.id}__epod-attachment-input`}
                  onButtonClick={() => this.setState({ openEpodAttachmentInput: true })}
                  onClose={() => this.setState({ openEpodAttachmentInput: false })}
                  open={this.state.openEpodAttachmentInput}
                  title={strings.Task.form.additionalInfo.epodAttachment.title}
                  value={data.epod_attachments || []}
                />
              )}
            </Components.Form.Block>
          </React.Fragment>
        )}

        <Components.Form.Divider />
        {codInputTemplate}
        {myjobsSetting.show_invoice_number ? [(
          <Components.Form.Block
            iconClassName="versa-invoice"
            iconText=""
            level={1}
          >
            {data.invoice_number || strings.Task.form.additionalInfo.noInvoiceNumber}
          </Components.Form.Block>
        ), (
          <Components.Form.Divider />
        )] : false}
        {myjobsSetting.show_price ? [(
          <Components.Form.Block
            iconClassName="versa-money"
            iconText=""
            level={1}
          >
            {data.price || strings.Task.form.additionalInfo.noPrice}
          </Components.Form.Block>
        ), (
          <Components.Form.Divider />
        )] : false}

        {myjobsSetting.show_tracking_id ? [(
          <Components.Form.Block iconClassName="versa-trackid" iconText="" level={1}>
            {data.tracking_id || strings.Task.form.additionalInfo.noTrackingId}
          </Components.Form.Block>
        ), (
          <Components.Form.Divider />
        )] : false}
      </Components.Form.ExpandableContainer>
    );
  }

  _renderSkill = (strings, skills) => (
    <React.Fragment>
      <Components.Form.Divider size="SMALL" />
      <Components.Form.Block level={2}>
        {strings.label}
      </Components.Form.Block>
      <Components.Form.Divider size="SMALL" />
      <Components.Form.Block level={2}>
        <Components.Form.Block>
          {
            !skills || skills.length === 0
              ? (
                <div className="vf-task__view-form__placeholder">
                  {strings.empty}
                </div>
              ) : (
                <Components.Tags
                  tagClassName="vf-task__view-form__tag"
                  tags={skills.map(skill => skill.name)}
                />
              )
          }
        </Components.Form.Block>
      </Components.Form.Block>
    </React.Fragment>
  );

  _renderSkillsList() {
    const { account, data } = this.props;

    if (!account?.addons_setting?.skills) {
      return null;
    }

    const strings = this.props.strings.Task.form;
    const isPartsSubscribed = account?.addons_setting?.parts_and_config;

    return (
      <div>
        <Components.Form.Block level={1}>
          {strings.constants.requirements}
        </Components.Form.Block>
        <Components.Form.Block fontColor="GREY" level={1}>
          {strings.constants.requirementsDesc}
        </Components.Form.Block>
        {this._renderSkill(strings.specificationRequirements.driverSpecifications,
          data.driver_skills)}
        {this._renderSkill(strings.specificationRequirements.vehicleSpecifications,
          data.vehicle_skills)}
        {isPartsSubscribed && this._renderSkill(
          strings.specificationRequirements.partSpecifications,
          data.vehicle_part_skills,
        )}
        <Components.Form.Divider size="MEDIUM" />
      </div>
    );
  }

  render() {
    const { data, strings } = this.props;
    if (Utils.Helper.isNullOrUndefined(data)) {
      return false;
    }

    let dividerColor;
    let taskStatus;

    switch (data.job.state) {
      case 'draft':
        taskStatus = data.job.state;
        dividerColor = Theme.Color.$bluedarker;
        break;
      case 'submitted':
        taskStatus = data.job.state;
        dividerColor = Theme.Color.$gold;
        break;
      case 'rejected':
        taskStatus = data.job.state;
        dividerColor = Theme.Color.$red;
        break;
      default:
        if (data.state === 'unassigned') {
          taskStatus = data.job.state;
          dividerColor = Theme.Color.$green;
        } else if (data.state === 'assigned'
            || data.state === 'waiting_for_acknowledgement') {
          taskStatus = data.state;
          dividerColor = Theme.Color.$gold;
        } else {
          switch (data.state) {
            case 'acknowledged':
            case 'started':
            case 'arrived':
            case 'collected':
            case 'ongoing':
            case 'successful':
            case 'completed':
              dividerColor = Theme.Color.$green;
              break;
            case 'failed':
            case 'cancelled':
              dividerColor = Theme.Color.$red;
              break;
            case 'pending':
              dividerColor = Theme.Color.$gold;
              break;
            default:
              dividerColor = Theme.Color.$white;
          }
          taskStatus = data.state;
        }
    }

    const stringsPickupInfo = strings.Job.form.pickupInfo;
    const time = Utils.Formatter.getInlineRangeDateTime(data.time_from, data.time_to).split(', ');

    const baseTask = data.job.base_task;
    const baseTaskTime = Utils.Formatter.getInlineRangeDateTime(baseTask.time_from, baseTask.time_to).split(', ');

    const isAdvancedVisibility = this.props.myjobsSetting.status_visibility === 'advanced';

    return (
      <div>
        {/* Task Detail */}

        <Components.Form.MobileMainHeader
          iconClassName={this.props.data.job.job_type === 'pickup' ? 'versa-arrow-up'
            : 'versa-arrow-down'}
          iconText=""
          status={strings.Task.status[taskStatus]}
          statusIcon={(
            <Components.Mobile.Divider
              color={dividerColor}
            />
          )}
          text={data.job.job_type === 'pickup' ? stringsPickupInfo.pickupFrom
            : stringsPickupInfo.deliveryTo}
        />
        <Components.Form.Block fontWeight="BOLD" level={1}>
          {(data.billing_account || {}).name
            || strings.Task.form.constants.noAccount}
          <br />
          {this.props.data.guid}
        </Components.Form.Block>
        <Components.Form.Divider />
        <Components.Form.Block iconClassName="versa-contact" level={1}>
          {Utils.Helper.isNonEmptyString(data.address.contact_person)
            ? [data.address.contact_person, <br />] : false}
          {Utils.Helper.isNonEmptyString(data.address.contact_number)
            ? [data.address.contact_number, <br />] : false}
          {Utils.Helper.isNonEmptyString(data.address.email)
            ? data.address.email : false}
        </Components.Form.Block>
        <Components.Form.Divider />
        <Components.Form.Block iconClassName="versa-marker-plain" iconText="" level={1}>
          {Utils.Helper.isNonEmptyString(this.props.data.address.name)
            ? [this.props.data.address.name, <br />] : false}
          {Utils.Helper.isNonEmptyString(this.props.data.address.line_1)
            ? [this.props.data.address.line_1, <br />] : false}
          {Utils.Helper.isNonEmptyString(this.props.data.address.line_2)
            ? [this.props.data.address.line_2, <br />] : false}
          {Utils.Helper.isNonEmptyString(this.props.data.address.city)
            ? [this.props.data.address.city, <br />] : false}
          {Utils.Helper.isNonEmptyString(this.props.data.address.zip)
            ? [this.props.data.address.zip, <br />] : false}
          {Utils.Helper.isNonEmptyString(this.props.data.address.country)
            ? this.props.data.address.country : false}
        </Components.Form.Block>
        <Components.Form.Divider />
        <Components.Form.Block iconClassName="versa-calendar-day" iconText="" level={1}>
          {moment(this.props.data.time_from).format('DD MMM YYYY')}
        </Components.Form.Block>
        <Components.Form.Divider />
        <Components.Form.Block iconClassName="versa-timelapse" iconText="" level={1}>
          <div>{time[0]}</div>
          {isAdvancedVisibility ? this._getEtaComponent() : false}
        </Components.Form.Block>

        <Components.Form.Divider size="LARGE" />

        {/* Job Detail */}

        <Components.Form.MobileMainHeader
          iconClassName={this.props.data.job.job_type === 'delivery' ? 'versa-base-pickup'
            : 'versa-base-delivery'}
          iconText=""
          status={this.props.strings.Job.status[this.props.data.state]}
          text={this.props.data.job.job_type === 'delivery' ? stringsPickupInfo.pickupFrom
            : stringsPickupInfo.deliveryTo}
        />
        <Components.Form.Block fontWeight="BOLD" level={1}>
          <a onClick={() => { transitionToJobDetail(this.props.data); }}>
            {this.props.data.job.customer.name}
          </a>
          <br />
          <a onClick={() => { transitionToJobDetail(this.props.data); }}>
            {this.props.data.job.guid}
          </a>
        </Components.Form.Block>
        <Components.Form.Divider />
        <Components.Form.Block iconClassName="versa-contact" level={1}>
          {Utils.Helper.isNonEmptyString(baseTask.address.contact_person)
            ? [baseTask.address.contact_person, <br />] : false}
          {Utils.Helper.isNonEmptyString(baseTask.address.contact_number)
            ? [baseTask.address.contact_number, <br />] : false}
          {Utils.Helper.isNonEmptyString(baseTask.address.email)
            ? baseTask.address.email : false}
        </Components.Form.Block>
        <Components.Form.Divider />
        <Components.Form.Block iconClassName="versa-marker-plain" iconText="" level={1}>
          {Utils.Helper.isNonEmptyString(baseTask.address.name)
            ? [baseTask.address.name, <br />] : false}
          {Utils.Helper.isNonEmptyString(baseTask.address.line_1)
            ? [baseTask.address.line_1, <br />] : false}
          {Utils.Helper.isNonEmptyString(baseTask.address.line_2)
            ? [baseTask.address.line_2, <br />] : false}
          {Utils.Helper.isNonEmptyString(baseTask.address.city)
            ? [baseTask.address.city, <br />] : false}
          {Utils.Helper.isNonEmptyString(baseTask.address.zip)
            ? [baseTask.address.zip, <br />] : false}
          {Utils.Helper.isNonEmptyString(baseTask.address.country)
            ? baseTask.address.country : false}
        </Components.Form.Block>
        <Components.Form.Divider />
        <Components.Form.Block iconClassName="versa-calendar-day" iconText="" level={1}>
          {moment(this.props.data.job.base_task.time_from).format('DD MMM YYYY')}
        </Components.Form.Block>
        <Components.Form.Divider />
        <Components.Form.Block iconClassName="versa-timelapse" iconText="" level={1}>
          {baseTaskTime[0]}
        </Components.Form.Block>

        <Components.Form.Divider size="LARGE" />

        {/* Additional Info */}
        {this._renderAdditionalInfo()}

        <Components.Form.Divider />

        {/* Custom Fields */}
        {
          Utils.Helper.isNullOrUndefined(this.props.data.custom_field_group) ? false
            : (
              <CustomInfoView
                customFieldGroup={this.props.customFieldGroups[
                  (this.props.data.custom_field_group || {}).id
                ]}
                customFields={this.props.data.custom_fields}
                data={this.props.data}
                id={`${this.props.id}__custom-info`}
                strings={this.props.strings.Task.form.customInfo}
              />
            )
        }

        {/* Specification Requirements */}
        {this._renderSkillsList()}

        <MeasurementModule.View data={this.props.data.measurements} />
      </div>
    );
  }
}

TaskDetail.propTypes = {
  account: PropTypes.shape({
    addons_setting: PropTypes.shape({
      skills: PropTypes.number,
      parts_and_config: PropTypes.number,
      use_own_epod: PropTypes.number,
    }),
  }).isRequired,
  customFieldGroups: PropTypes.shape({}).isRequired,
  data: PropTypes.shape({
    time_from: PropTypes.string,
    time_type: PropTypes.string,
    time_to: PropTypes.string,
    state: PropTypes.string,
    job: PropTypes.shape({
      base_task: PropTypes.shape({
        address: PropTypes.shape(),
        time_from: PropTypes.string,
        time_to: PropTypes.string,
      }),
      customer: PropTypes.shape({
        name: PropTypes.string,
      }),
      guid: PropTypes.string,
      id: PropTypes.number,
      job_type: PropTypes.string,
      myjobs_rejection_notes: PropTypes.arrayOf(PropTypes.shape({
        content: PropTypes.string,
      })),
      state: PropTypes.string,
    }),
    tags: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
    })),
    photos: PropTypes.arrayOf(PropTypes.shape()),
    epod_attachments: PropTypes.arrayOf(PropTypes.shape()),
    billing_account: PropTypes.shape({
      name: PropTypes.string,
    }),
    guid: PropTypes.string,
    address: PropTypes.shape({
      contact_person: PropTypes.string,
      contact_number: PropTypes.string,
      email: PropTypes.string,
      name: PropTypes.string,
      line_1: PropTypes.string,
      line_2: PropTypes.string,
      city: PropTypes.string,
      zip: PropTypes.string,
      country: PropTypes.string,
    }),
    remarks: PropTypes.string,
    custom_field_group: PropTypes.shape({
      id: PropTypes.number,
    }),
    custom_fields: PropTypes.arrayOf(PropTypes.shape()),
    driver_skills: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
    })),
    vehicle_skills: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
    })),
    vehicle_part_skills: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
    })),
    measurements: PropTypes.arrayOf(PropTypes.shape()),
    invoice_number: PropTypes.string,
    price: PropTypes.number,
    tracking_id: PropTypes.number,
    expected_cod: PropTypes.number,
    actual_cod: PropTypes.number,
    task_assignment: PropTypes.shape({
      estimated_start_time: PropTypes.string,
    }),
  }).isRequired,
  dispatch: PropTypes.func,
  id: PropTypes.string,
  myjobsSetting: PropTypes.shape({
    show_additional_info: PropTypes.bool,
    show_invoice_number: PropTypes.bool,
    show_price: PropTypes.bool,
    show_note: PropTypes.bool,
    show_tags: PropTypes.bool,
    show_tracking_id: PropTypes.bool,
    status_visibility: PropTypes.string,
  }).isRequired,
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      constants: PropTypes.shape({
        none: PropTypes.string,
      }),
      form: PropTypes.shape({
        additionalInfo: PropTypes.shape({
          noRemarks: PropTypes.string,
        }),
        pickupInfo: PropTypes.shape({
          pickupFrom: PropTypes.string,
          deliveryTo: PropTypes.string,
        }),
      }),
      status: PropTypes.shape(),
    }),
    Task: PropTypes.shape({
      form: PropTypes.shape({
        additionalInfo: PropTypes.shape({
          epodAttachment: PropTypes.shape({
            button: PropTypes.string,
            noAttachments: PropTypes.string,
            title: PropTypes.string,
          }),
          cod: PropTypes.shape({
            title: PropTypes.string,
            expected: PropTypes.string,
            notCollected: PropTypes.string,
            actual: PropTypes.string,
          }),
          title: PropTypes.string,
          jobRejected: PropTypes.string,
          noInvoiceNumber: PropTypes.string,
          noPrice: PropTypes.string,
          noTrackingId: PropTypes.string,
        }),
        constants: PropTypes.shape({
          eta: PropTypes.string,
          trackTask: PropTypes.string,
          noAccount: PropTypes.string,
          requirements: PropTypes.string,
          requirementsDesc: PropTypes.string,
        }),
        specificationRequirements: PropTypes.shape({
          title: PropTypes.string,
          description: PropTypes.string,
          driverSpecifications: PropTypes.shape({
            label: PropTypes.string,
            placeholder: PropTypes.string,
          }),
          vehicleSpecifications: PropTypes.shape({
            label: PropTypes.string,
            placeholder: PropTypes.string,
          }),
          partSpecifications: PropTypes.shape({
            label: PropTypes.string,
            placeholder: PropTypes.string,
          }),
        }),
        customInfo: PropTypes.shape(),
      }),
      status: PropTypes.shape(),
    }),
  }).isRequired,
  trackingSetting: PropTypes.shape({
    is_enabled: PropTypes.bool,
    tracking_url: PropTypes.string,
  }).isRequired,
};

TaskDetail.defaultProps = {
  id: 'vf-task__detail',
  dispatch: {},
};

const mapStateToProps = (state) => {
  const { account, profile } = state;
  return {
    account: account.account,
    myjobsSetting: (profile.profile || {}).myjobs_setting,
    trackingSetting: account.trackingSetting,
  };
};

export default connect(mapStateToProps)(translate('')(TaskDetail));
